import { Suspense } from "react";

const withSuspense = <P extends object>(
    Component: React.ComponentType<P>
): React.FC<P> => ({
    ...props
}) => {
        return (
            <Suspense fallback="loading">
                <Component {...props as P} />
            </Suspense>
        )
    }

export default withSuspense